import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useContext } from "react";
import { rootContexts } from "../../contexts/rootContexts";
import { IoMdClose } from "react-icons/io";

import Signup from "./Signup";
import Login from "./Login";


export default function Auth() {
  //   let [isOpen, setIsOpen] = useState(true)
  const { asLogin, setAsLogin } = useContext(rootContexts);
 

  function closeModal() {
    setAsLogin(false);
  }

  return (
    <>
      <Transition appear show={asLogin} as={Fragment}>
        <Dialog as="div" className="relative z-[4050] " onClose={()=>{}}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/25 before:absolute before:w-full before:h-full before:backdrop-blur-sm		" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full  max-w-2xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <div className="py-3 ">
                    <IoMdClose
                      className="text-3xl cursor-pointer"
                      onClick={closeModal}
                    />
                  </div>
                      <Login />
                  <div className="py-7">
                    <h1 className="p !text-2xl relative z-10 text-beta text-center after:absolute after:left-0  after:-z-20 after:top-2/3 after:w-full after:h-[1px] after:bg-beta ">
                      <span className="bg-white  px-4 h-full relative">or</span>
                    </h1>
                  </div>
                 <Signup />
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
